import { ListRequest } from '../../providers/request/list-request.model';
import { OrderType } from '../../providers/request/order-type.enum';

export class JgVisualInspUnitFbListRequest extends ListRequest {
  projectId?: number;
  jgSectionId?: number;
  sectionId?: number;
  dwTypeName?: string;
  dwTypeNameSort?: number;
  dwSectionItemId?: number;
  dwCode?: string;
  dwCodeSort?: number;
  dwName?: string;
  jgFbName?: string;
  jgFbNameSort?: number;
  initScore?: number;
  finalScore?: number;
  sortOrder?: number;
  inRecycleBin?: boolean;
  comment?: string;
  dwCodeSortOrder?: OrderType;
  dwMileage?: string;
}
